import { useEffect, useState } from 'react';
import { useMutation } from '../../hooks/useApi';
import { useSession } from '../../session/SessionContext';
import { Card, Field, LiveRegion } from '../../components/ui';
import { InlineError } from '../../components/ErrorView';
import { Loading } from '../../components/ui';
import { routes } from '../../api/routes';

export function Profile() {
  const { me, refresh, signOut } = useSession();
  const [form, setForm] = useState({ display_name: '', bio: '', timezone: '' });
  const save = useMutation<Record<string, unknown>, unknown>(routes.me.profile, { method: 'PATCH' });

  useEffect(() => {
    if (me) setForm({ display_name: me.display_name, bio: me.bio, timezone: me.timezone });
  }, [me]);

  if (!me) return <Loading label="Loading your profile" />;

  return (
    <div className="narrow">
      <Card title="Profile">
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if ((await save.run(form)) !== null) await refresh();
          }}
        >
          <Field id="p-handle" label="Handle" hint="Your handle cannot be changed.">
            <input id="p-handle" className="input" value={me.handle} readOnly />
          </Field>
          <Field id="p-name" label="Display name">
            <input
              id="p-name"
              className="input"
              value={form.display_name}
              onChange={(e) => setForm({ ...form, display_name: e.target.value })}
            />
          </Field>
          <Field id="p-bio" label="Bio">
            <textarea
              id="p-bio"
              className="textarea"
              rows={4}
              value={form.bio}
              onChange={(e) => setForm({ ...form, bio: e.target.value })}
            />
          </Field>
          <Field id="p-tz" label="Timezone" hint="Used for the times shown alongside each bot's own zone.">
            <input
              id="p-tz"
              className="input"
              value={form.timezone}
              onChange={(e) => setForm({ ...form, timezone: e.target.value })}
            />
          </Field>
          {save.problem ? <InlineError problem={save.problem} /> : null}
          <button type="submit" className="btn btn-primary" disabled={save.pending}>
            {save.pending ? 'Saving…' : 'Save'}
          </button>
          {save.data ? <LiveRegion>Saved.</LiveRegion> : null}
        </form>
      </Card>

      <Card title="Session">
        <p className="muted">Signed in as @{me.handle} ({me.email}).</p>
        <button type="button" className="btn" onClick={() => void signOut()}>
          Sign out
        </button>
      </Card>
    </div>
  );
}
